import { Link } from 'react-router-dom';
import Card from '@/components/Card';

import { allProjects } from '@/contexts/Projects';

export default function Home() {
  return (
    <div className='min-h-screen divide-y-2 divide-gray-800 dark:divide-white'>
      <div className='py-16 text-left'>
        <h1 className='font-sans text-sm font-bold md:text-xl'>Hi!</h1>
        <h1 className='font-sans text-3xl font-bold md:text-5xl'>
          You can call me <span className='underline'>Faizin</span>
        </h1>
        <p className='mt-4 font-serif text-sm md:text-base'>
          I'm a easy going Informatics Engineering Students at Institute of
          Technology Sepuluh Nopember. I'm a developer with some experiences as
          website development.
        </p>
      </div>
      <div className='py-4'>
        <h2 className='mb-4 font-sans text-2xl font-bold text-left md:text-3xl'>
          My Projects
        </h2>
        <div className='py-4'>
          <div className='flex flex-col gap-4 md:grid md:grid-cols-2 xl:grid-cols-3'>
            {allProjects.slice(0, 3).map((card) => (
              <Card
                key={card.title}
                title={card.title}
                description={card.description}
                reflink={card.link}
              />
            ))}
          </div>
        </div>
        <div className='mt-2'>
          <Link
            to='/projects'
            className='p-2 text-base transition duration-300 bg-white border border-gray-300 rounded-lg shadow-sm md:text-lg text-dark focus:ring-offset-2 focus:ring-gray-900-100 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-200 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-600 dark:focus:ring-gray-700'
          >
            <span>More projects</span>
          </Link>
        </div>
      </div>
    </div>
  );
}
